export function money(value: string | number | null | undefined, digits = 2): string {
  const number = Number(value);
  if (!Number.isFinite(number)) return '—';
  return number.toLocaleString('zh-CN', { minimumFractionDigits: digits, maximumFractionDigits: digits });
}

export function time(value: string | null | undefined): string {
  if (!value) return '尚未同步';
  return new Date(value).toLocaleString('zh-CN', { hour12: false });
}

export function signedMoney(value: string | number | null | undefined): { text: string; tone: string } {
  const number = Number(value ?? 0);
  return {
    text: `${number > 0 ? '+' : ''}${money(number)}`,
    tone: number > 0 ? 'positive' : number < 0 ? 'negative' : 'neutral'
  };
}
